module.exports = __webpack_public_path__ + "img/Dingo PHL.50bc03a6.png";